import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const CheckList = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill={fill}
      {...rest}
      width={Sizes[size]}
      height={Sizes[size]}
    >
      <g transform="translate(2 2)">
        <path d="M18.4 4H9.6a.8.8 0 1 0 0 1.6h8.8a.8.8 0 1 0 0-1.6z" />
        <rect width="6.4" height="6.4" rx=".8" transform="translate(.8 1.6)" />
        <path d="M18.4 13.6H9.6a.8.8 0 1 0 0 1.6h8.8a.8.8 0 1 0 0-1.6z" />
        <path d="M8 10.069l-4.8 4.8-1.6-1.6L.469 14.4l2.166 2.166a.8.8 0 0 0 1.131 0L9.131 11.2z" />
      </g>
    </svg>
  );
};

CheckList.displayName = 'CheckList';
